export const notification = {
  namespaced: true,
  state: {
    notificationPayload: null,
    notificationId: 0,
  },
  actions: {
    receiveNotification({ commit }, payload) {
      commit('setNotification', payload);
    },
  },
  mutations: {
    setNotification(state, payload) {
      state.notificationPayload = payload;
      // Combine timestamp with random number for guaranteed uniqueness
      state.notificationId = Date.now() + Math.random();
    },
  },
  getters: {
    notificationId(state) {
      return state.notificationId;
    },
    getNotificationPayload(state) {
      return state.notificationPayload;
    },
  }
};